<div>
  <mat-radio-group [formControl]="methodControl" fxLayout="column">
    <mat-card
      (click)="onMethodClicked(method)" *ngFor="let method of methods"
      [class.disabled]="!method.available || disabledChooser" [class.clickable]="method.available &&
      !method.loading && !disabledChooser" [class.selected]="methodControl.value === method.code"
      [matTooltip]="method.tooltip" matTooltipTouchGestures="off" fxFlex>
      <div fxLayout="row" fxLayoutGap="8px">
        <div fxFlex fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
          <div [ngStyle]="{ opacity: isChosen(method) ? 1 : 0.3 }">
            <app-icon name="check" [height]="12" [width]="12"></app-icon>
          </div>
          <div *ngIf="method.code !== paymentMethodCode.FAST_TRANSFER && method.code !== paymentMethodCode.AUTO_PAYMENT"
               class="image">
            <img [alt]="method.name" [src]="method.image">
          </div>
          <app-icon *ngIf="method.code === paymentMethodCode.FAST_TRANSFER" name="account_balance_wallet"></app-icon>
          <app-icon *ngIf="method.code === paymentMethodCode.AUTO_PAYMENT" name="alarm_on"></app-icon>
          <div class="description" fxFlex fxLayout="row" fxLayoutAlign="end center">
            <ng-container *ngIf="!inProgress || methodControl.value !== method.code; else loadingText">

            <span *ngIf="method.code === paymentMethodCode.DEFER; else payMethodDesc">
              {{ method.name }}  <b>{{ amount | paykaCurrency }}</b>
            </span>
            <ng-template #payMethodDesc>{{ method.name }}</ng-template>
            <a
              href="https://payappka.document360.io/docs/jak-dokonac-p%C5%82atnosci-przy-uzyciu-imoje-p%C5%82ace-pozniej"
              target="_blank">
              <app-icon *ngIf="method.code === paymentMethodCode.TWISTO" class="twisto-help-icon" name="help">
              </app-icon>
            </a>
            </ng-container>
            <ng-template #loadingText>
              {{ method.loadingText !== null ? method.loadingText : 'W trakcie opłacania' }}
              <mat-spinner style="margin-left: 12px;" [diameter]="18"></mat-spinner>
            </ng-template>


          </div>

          <div *ngIf="method.code === paymentMethodCode.TWISTO && method.loading">
            <mat-spinner [diameter]="21" class="twisto-loading-spinner"></mat-spinner>
          </div>
        </div>
      </div>

      <div
        class="twisto-info"
        *ngIf="method.code === paymentMethodCode.TWISTO && methodControl.value === paymentMethodCode.TWISTO">
        <ol>
          <li><a href="https://www.twisto.pl/" target="_blank">Twisto</a> płaci za Twoje opłaty teraz</li>
          <li>Dostawca otrzymuje środki w terminie</li>
          <li>
            Ty oddajesz środki&nbsp;w ciągu 30&nbsp;dni lub nawet 45&nbsp;dni - dzięki wcześniejszej rejestracji&nbsp;z
            <a href="https://www.twisto.pl/" target="_blank">Twisto</a>
          </li>
        </ol>
      </div>

      <div *ngIf="method.code === paymentMethodCode.FAST_TRANSFER" class="fast-transfer">
        <img alt="Fast transfer banks" class="fast-transfer__image"
             src="../../../../assets/images/payment-methods/mu_payment_methods_transparent.png"
        />
      </div>
    </mat-card>
  </mat-radio-group>
</div>
